import { ImageIcon } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

// Bloc gris neutre, clairement remplaçable par une vraie photo.
// Le nom (label) permet d'identifier l'emplacement : ex. "MAISON-EXT-01".
export const ImagePlaceholder = ({
  label,
  ratio = "aspect-[4/3]",
  className = "",
  dark = false,
}) => {
  const { t } = useLanguage();
  return (
    <div
      data-testid={`img-${label.toLowerCase()}`}
      className={`placeholder-grid-lines relative w-full overflow-hidden border ${ratio} ${
        dark
          ? "border-ink/10 bg-neutral-300 text-ink/60"
          : "border-neutral-200 bg-neutral-100 text-neutral-400"
      } ${className}`}
    >
      <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 px-4 text-center">
        <ImageIcon className="h-5 w-5 opacity-50" strokeWidth={1.5} />
        <span className="font-sans text-[11px] font-medium uppercase tracking-[0.22em]">
          {label}
        </span>
        <span className="font-sans text-[10px] uppercase tracking-[0.18em] opacity-60">
          {t.imageToCome}
        </span>
      </div>
    </div>
  );
};
